import {translation} from "@2d-front-monorepo/core";
import {useInitializeMvvmContext, MvvmButton, MvvmDataProvider} from "@2d-front-monorepo/design-library";
import {PermitsMvvmErrorCollector} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback} from "react";
import {useNavigate} from "react-router";
import UserData from "../../content-blocks/UserData";
import {getDefaultLandingPage} from "../../functions";
import {getGlobalContext} from "../../hooks/getGlobalContext";
import {getHttpClient} from "../../hooks/getHttpClient";
import {ReloadEntities, reloadPermits} from "../../hooks/reloadPermits";
import {usePermits} from "../../hooks/usePermits";

type CompleteProfileModel = {
	givenName: string
	familyName: string
	phone: string
}

export default function CompleteProfile(): JSX.Element {
	const global = getGlobalContext();
	const permits = usePermits();
	const navigate = useNavigate();
	const user = permits.holder;

	const {context} = useInitializeMvvmContext({
		initialState: () => {
			return {
				givenName: user.givenName ?? "",
				familyName: user.familyName ?? "",
				phone: user.cellPhone?.phone ?? ""
			}
		}
	});

	const onSubmit = useCallback(async function (data: CompleteProfileModel): Promise<void> {
		await getHttpClient().holder.update({
			userInfo: {
				givenName: data.givenName,
				familyName: data.familyName,
				email: user.email,
				phone: {
					countryCode: global.installation.countryId,
					phone: data.phone
				}
			}
		});

		await reloadPermits(ReloadEntities.Holder);
		navigate(getDefaultLandingPage(), {replace: true});
	}, [navigate, user.email]);

	return (
		<section className="full-layout full-layout--centered">
			<MvvmDataProvider<CompleteProfileModel> context={context} onSubmit={onSubmit}>
				<h1>{translation(PermitTranslations.complete_profile_page__title)}</h1>
				<p>{translation(PermitTranslations.complete_profile_page__subtitle)}</p>
				<div className="layout vertical gap">
					<PermitsMvvmErrorCollector/>

					<UserData global={global} context={context} hideEmail={true}/>

					<div className="form__buttons">
						<MvvmButton kind="primary">{translation(PermitTranslations.save_changes)}</MvvmButton>
					</div>
				</div>
			</MvvmDataProvider>
		</section>
	)
}
